// extracted by mini-css-extract-plugin
export default {"container":"syWSdE","headerContainer":"QxacT2","commentCount":"cBjtJ2","text":"Y0jtNF","buttonContainer":"IDs3lt","refreshButton":"PpgWMN","errorCode":"IpBSAE"};